import React, { useState, useEffect, Fragment } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core";
import firebase from "../../../utils/firebase";

import GridItem from "components/MaterialKit/Grid/GridItem.js";

import Card from "components/MaterialKit/Card/Card.js";

import styles from "assets/jss/material-kit-react/views/loginPage.js";

import EnhancedRegisterForm from "./EnhancedRegisterForm";
import { useHistory } from "react-router-dom";

import { DASHBOARD } from "constants/routes";
import { useSelector, shallowEqual } from "react-redux";
import AutoRegister from "./AutoRegister";

const useStyles = makeStyles(styles);

export default function Register(props) {
  const [signedIn, setSignedIn] = useState(false);
  const [cardAnimaton, setCardAnimation] = useState("cardHidden");

  const image = require("assets/img/main/gaming.gif");
  setTimeout(function () {
    setCardAnimation("");
  }, 700);
  const classes = useStyles();

  const history = useHistory();

  const { isAuthenticated } = useSelector((state) => {
    return {
      isAuthenticated: state.auth.isAuthenticated,
      loading: state.auth.loading,
    };
  }, shallowEqual);

  useEffect(() => {
    if (isAuthenticated) {
      history.push(DASHBOARD);
    }
  }, [isAuthenticated, history]);
  useEffect(() => {
    firebase.auth().onAuthStateChanged((user) => {
      setSignedIn(!!user);
      console.log("user in top level file", user);
    });
    //eslint-disable-next-line
  }, []);

  return (
    <div>
      <div
        className={classes.pageHeader}
        style={{
          backgroundImage: "url(" + image + ")",
          backgroundSize: "cover",
          backgroundPosition: "top center",
        }}
      >
        <div className={classes.container} style={{ width: "100%" }}>
          {/* <GridContainer
            style={{
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <GridItem xs={12} sm={12} md={6}>
              <h1 className={classes.title}>Gamers World</h1>
              <h4>
                Register with us and share youe content with users around the
                world.
              </h4>
              <br />

              <Button justIcon color='success' size='lg' round>
                <i className='fas fa-arrow-right'></i>
              </Button>
            </GridItem>
            <br />
            <br /> */}
          <GridItem xs={12} sm={12} md={6} style={{ margin: "3rem auto" }}>
            <Card className={classes[cardAnimaton]} style={{ width: "100%" }}>
              {signedIn ? (
                <Fragment>
                  <AutoRegister />
                </Fragment>
              ) : (
                <Fragment>
                  <EnhancedRegisterForm history={history} />
                </Fragment>
              )}
            </Card>
          </GridItem>
          {/* </GridContainer> */}
        </div>
      </div>
    </div>
  );
}
